<h2 mat-dialog-title class="text-lg font-bold mb-1">
   Frecuencia
</h2>
<mat-dialog-content class="modal-content">
    <div>
        <form class="w-full flex items-center grid grid-cols-1 gap-4 sm:grid-cols-3 md:grid-cols-3">
            <mat-form-field appearance="fill" class="w-full">
                <mat-label>Frecuencia de visita</mat-label>
                <mat-select [(ngModel)]="frecuency" name="frecuency" (selectionChange)="changeFrecuency()">
                    @for (frecuency of listFrecuency; track frecuency) {
                    <mat-option [value]="frecuency.code">
                        {{ frecuency.name }}
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <div [ngSwitch]="frecuency">
                <!-- Día -->
                <div *ngSwitchCase="'W'" >
                    <!-- <p class="mb-2" style="color: #1E293B;">Selecciona los días:</p>
                    <div class="grid-container">
                        <div *ngFor="let day of daysList" >
                            <mat-checkbox style="width: 12px; height: 12px;" color="primary" [(ngModel)]="day.selected"
                            name="selectedDay{{ day.code }}" (change)="onDaySelectionChange(day)">{{ day.day }}</mat-checkbox>
                        </div>
                    </div> -->
                    <mat-form-field appearance="fill" class="w-full">
                        <mat-label>Frecuencia</mat-label>
                        <mat-select [(ngModel)]="selectedFrecuency" name="selectedFrecuency" required>
                          <mat-option *ngFor="let frecuency of listFrecuencies" [value]="frecuency">
                            {{ getFrecuencyDays(frecuency.days) }}
                          </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
          
                <!-- 2/3/4 -->
                <div *ngIf="isMonthlyOrQuarterly()" class="flex items-center gap-4 w-full sm:w-96">
                    <mat-form-field class="w-full">
                        <mat-label>Iniciar en</mat-label>
                        <input matInput [matDatepicker]="chargeDatePicker" [(ngModel)]="selectedDate"  name="selectedDate" [min]="today()">
                        <mat-datepicker-toggle matIconSuffix [for]="chargeDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #chargeDatePicker></mat-datepicker>
                    </mat-form-field>
                <!-- </div> -->

                <!-- Finalizar en -->
                 <!-- <div *ngIf="isMonthlyOrQuarterly()"> -->
                    <mat-form-field class="w-full">
                        <mat-label>Finalizar en</mat-label>
                        <input matInput [matDatepicker]="endDatePicker" [(ngModel)]="selectedEndDate" name="selectedEndDate" 
                            [min]="this.selectedDate" [max]="limitDate()" [disabled]="!selectedDate">
                        <mat-datepicker-toggle matIconSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #endDatePicker></mat-datepicker>
                    </mat-form-field>
                </div>
                <!-- Agenda -->
                <div *ngSwitchCase="'C'" class="flex items-center">
                    <mat-form-field class="w-full">
                        <mat-label>Asignar fecha</mat-label>
                        <input matInput [matDatepicker]="chargeDatesPicker" [(ngModel)]="selectedDateAgend"  name="selectedDateAgend" [min]="today()">
                        <mat-datepicker-toggle matIconSuffix [for]="chargeDatesPicker"></mat-datepicker-toggle>
                        <mat-datepicker #chargeDatesPicker></mat-datepicker>
                    </mat-form-field>
                    <button mat-icon-button class="mt-4" color="primary" (click)="addDate()" matTooltip="Agregar fecha">
                        <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
                  </button>
                </div>
            </div>

            <div class="flex justify-end w-full sm:w-auto">
                <button class="h-8 w-full sm:w-28 md:w-32 mt-4" *ngIf="frecuency" mat-raised-button color="primary" [disabled]="(frecuency == 'W' && !selectedFrecuency) || (isMonthlyOrQuarterly() && !(selectedDate && selectedEndDate)) || (frecuency == 'C' && selectedDates.length == 0)" (click)="openCalendar()">
                    Calendarizar
                    <mat-icon class="icon-size-5" svgIcon="heroicons_solid:magnifying-glass-circle"></mat-icon>
                </button>
            </div>
        </form>

        <div class="flex flex-wrap gap-2 mb-1">
            <mat-chip-set>
                <mat-chip *ngFor="let date of selectedDates" [removable]="true" (removed)="removeDate(date)">
                    {{ date | date: 'dd/MM/yyyy' }}
                    <button matChipRemove>
                        <mat-icon svgIcon="heroicons_solid:x-circle"></mat-icon>
                    </button>
                </mat-chip>
            </mat-chip-set>
        </div>
    </div>

    <div [ngSwitch]="view">
        @if(this.isCalendarVisible){
            <full-calendar [options]="calendarOptions"></full-calendar>
        }
    </div>
</mat-dialog-content>
<mat-dialog-actions class="modal-actions flex">
    <button mat-button mat-dialog-close class="align-left">Cancelar</button>
    <button mat-raised-button color="primary" (click)="onSubmit()"class="justify-end" [disabled]="!isCalendarVisible">Guardar</button>
</mat-dialog-actions>  